import _Button from "@material-ui/core/esm/Button";
import React from 'react';
import classnames from 'classnames';
import CSSclasses from '../../advice-banner.scss';
export const Contacts = ({
  contacts,
  isBoxesPage,
  classes,
  onChatClick
}) => {
  const renderBoxesPageText = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, ". We\u2019ll be happy to help or", /*#__PURE__*/React.createElement("br", null), "point you in the right direction."), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.getInTouchButton
  }, /*#__PURE__*/React.createElement(_Button, {
    variant: "contained",
    className: classes === null || classes === void 0 ? void 0 : classes.button
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${contacts === null || contacts === void 0 ? void 0 : contacts.email}`
  }, "GET IN TOUCH"))));
  const shouldShowPhone = Boolean(contacts === null || contacts === void 0 ? void 0 : contacts.companyShowPhone) && Boolean(contacts === null || contacts === void 0 ? void 0 : contacts.phone);
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Email us at\xA0", /*#__PURE__*/React.createElement("a", {
    href: `mailto:${contacts === null || contacts === void 0 ? void 0 : contacts.email}`,
    className: CSSclasses.actionable
  }, contacts === null || contacts === void 0 ? void 0 : contacts.email), Boolean(contacts === null || contacts === void 0 ? void 0 : contacts.isChatAvailable) && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0or contact us through\xA0", /*#__PURE__*/React.createElement("span", {
    className: CSSclasses.actionable,
    onClick: onChatClick
  }, "chat")), shouldShowPhone && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0or call us at\xA0", /*#__PURE__*/React.createElement("a", {
    href: `tel:${contacts === null || contacts === void 0 ? void 0 : contacts.phone}`,
    className: classnames(CSSclasses.subtitle, CSSclasses.phone)
  }, contacts === null || contacts === void 0 ? void 0 : contacts.phone), "\xA0"), isBoxesPage && renderBoxesPageText());
};